import Vue from 'vue'
import App from '../../app_business.vue'
import '../../assets/js/element-ui'
import store from '../../vuex/index'
Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App),

}).$mount('#app2')